import { jsx as r } from "react/jsx-runtime";
import { useMemo as B } from "react";
import { a as P } from "../../core-DVmjA3_O.js";
import "../../type-Dku6Xzl6.js";
import V from "../ButtonLayout/index.js";
import R from "../RawButton/index.js";
import '../../index13.css';const _ = "_button_qth5l_1", F = {
  button: _
};
function C(e) {
  const {
    colorVariant: o,
    styleVariant: t = "outline",
    spacing: i,
    spacingOffset: a = -3,
    withoutPadding: s,
    withFullWidth: u,
    withoutAdditionalInlinePadding: l,
    before: m,
    after: c,
    textSize: f,
    layoutElementRef: p,
    name: d,
    onClick: b,
    children: h,
    disabled: n,
    className: y,
    type: w = "button",
    ...g
  } = e, x = B(() => P(o) ? o : t === "action" || t === "transparent" ? "text" : "primary", [t, o]);
  return /* @__PURE__ */ r(
    R,
    {
      ...g,
      className: F.button,
      name: d,
      onClick: b,
      type: w,
      disabled: n,
      children: /* @__PURE__ */ r(
        V,
        {
          className: y,
          elementRef: p,
          colorVariant: x,
          styleVariant: t,
          spacing: i,
          spacingOffset: a,
          withoutPadding: s,
          withoutAdditionalInlinePadding: l,
          withFullWidth: u,
          before: m,
          after: c,
          textSize: f,
          disabled: n,
          children: h
        }
      )
    }
  );
}
export {
  C as default
};
